import { useState, useEffect } from "react"
import "./cartItem.css"

export function CartItem({ itemId, cartItem, itemQuantity, cartClone, setCartClone }) {
    const [quantity, setQuantity] = useState(itemQuantity)
    const [removeDisplay, setRemoveDisplay] = useState(false)

    useEffect(() => {
        const updatedCart = cartClone.map(e => {
            if(e.customId === itemId) {
                return { ...e, quantity }
            } else {
                return e
            }
        })
        setCartClone(updatedCart)
    }, [quantity])

    function removeCartItem() {
        const updatedCart = cartClone.filter(e => e.customId !== itemId)
        setCartClone(updatedCart)
    }

    return (
        <tr className="align-items-center w-100 px-4 py-3 cart-item off-lg-flx"
            onMouseEnter={() => setRemoveDisplay(true)}
            onMouseLeave={() => setRemoveDisplay(false)}>
            <td className="d-flex align-items-center gap-4 w-25">
                <div className="position-relative">
                    <img src={cartItem.image} width={50} height="auto" alt="" />
                    <div
                        onClick={removeCartItem}
                        className={`red-remove position-absolute ${removeDisplay ? "" : "off"}`}>
                    </div>
                </div>
                <div className="">
                    <div className="w-100 item-title">{cartItem.title}</div>
                    <div className="d-flex align-items-center gap-3">
                        
                        <div className="rounded-circle product-color " style={{
                            backgroundColor: cartItem.color
                        }}></div>
                        <div className="d-flex cntr pt-1">
                            {cartItem.size}
                        </div>
                    </div>
                </div>
            </td>

            <td className="d-flex w-25 cart-item-price justify-content-center">
                ${cartItem.salePrice ? cartItem.salePrice : cartItem.regularPrice}
            </td>

            <td className="w-25 d-flex justify-content-center pe-4">
                <div className="d-flex cart-item-quantity">
                    <input type="number" value={quantity} readOnly />
                    <div className="d-flex flex-column">
                        <div
                            className="q-arrow-up"
                            onClick={() => setQuantity(quantity + 1)}>
                        </div>
                        <div
                            className="q-arrow-down"
                            onClick={() => quantity > 1 && setQuantity(quantity - 1)}>
                        </div>
                    </div>
                </div>
            </td>

            <td className="w-25 text-end">
                ${
                    parseFloat((
                        (cartItem.salePrice ? cartItem.salePrice : cartItem.regularPrice) * quantity
                    ).toPrecision(6))
                }
            </td>

        </tr>
    )
}